@if (showMenubar()) {
    <app-menubar></app-menubar>
    <app-page-header></app-page-header>
}

<router-outlet></router-outlet>
<horizon-toast></horizon-toast>
<bcu-spinner></bcu-spinner>
<bcu-modal></bcu-modal>

<horizon-app-version-footer backgroundColor="#F6FAFF" strokeColor="#E9EEF2"></horizon-app-version-footer>
